<template>
  <div
    class="search-filters-body"
  >
    <CustomRefinementList
      v-for="searchFacet in TOP_STATIC_FACETS"
      :key="searchFacet.attribute"
      :facet="searchFacet.attribute"
      :hide-title="searchFacet.hideTitle"
    />
  </div>
</template>

<script lang="ts">

import { TOP_STATIC_FACETS } from '~~/constants/typesense';
import extractDynamicFacets from '~~/helpers/typesense/extractDynamicFacets';

export default defineComponent({
  name: 'SearchFiltersBody',

  setup () {

    return {
      TOP_STATIC_FACETS,
      extractDynamicFacets,
    };

  },
});

</script>
